var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card mt-3",attrs:{"id":"feedback"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_c('h4',[_vm._v("Đánh giá")])])]),(_vm.infomation)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.infomation.feedback)}}):_c('div',[_vm._v("Không có thông tin đánh giá")])])
}
var staticRenderFns = []

export { render, staticRenderFns }